import { fetchPatients } from "@/redux/thunks/patients.thunk";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { createAppointment, deleteAppointment, getAppointmentsByTherapist, reminderAppointment, updateAppointment } from "../../services/appointment/appointment.service";

export const createAppointments = createAsyncThunk(
  'appointment/createAppointments',  
  async ({therapist_id, date, duration, is_online, patient_id}: {therapist_id: string, date: string, is_online: string, duration: string, patient_id: number}, thunkAPI) => {    
    try {
      const {data} = await createAppointment(therapist_id, date, duration, is_online, patient_id, 'pending');
      thunkAPI.dispatch(fetchPatients({therapist_id}));
      return data;  
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateAppointments = createAsyncThunk(
  'appointment/updateAppointment',  
  async ({therapist_id, appointment_id, date, is_online, duration, status}: {therapist_id: string, appointment_id: string, is_online?: string, date?: string, duration?: string, status: string}, thunkAPI) => {    
    try {
      const {data} = await updateAppointment(appointment_id, date, is_online, duration, status);
      return thunkAPI.dispatch(fetchPatients({therapist_id}));
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const sendReminder = createAsyncThunk(
  'appointment/sendReminder',  
  async ({appointment_id}: {appointment_id: string}, thunkAPI) => {    
    try {
      const {data} = await reminderAppointment(appointment_id);
      return true
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAppointments = createAsyncThunk(
  'appointment/deleteAppointment',  
  async ({therapist_id, appointment_id}: {therapist_id: string, appointment_id: string}, thunkAPI) => {    
    try {
      const {data} = await deleteAppointment(appointment_id);
      return thunkAPI.dispatch(fetchPatients({therapist_id}));
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchAppointments = createAsyncThunk(
  'appointment/fetchAppointments',  
  async ({therapist_id}: {therapist_id: string}, thunkAPI) => {    
    try {
      const { data } = await getAppointmentsByTherapist(therapist_id);
      return data;  
    } catch (error) {
      return thunkAPI.rejectWithValue('Error fetching appointments');
    }
  }
);